import React from 'react';
import PageLayout from "../components/page-layout";

export default function Logs() {

    return (
        <PageLayout pageTitle="گزارش لاگ‌ها">

        </PageLayout>
    );
}

